// Popup.jsx
import React from 'react';
import Draggable from 'react-draggable';

const PopupMobile = ({ children, onClose, onback }: any) => {
    return (
        <Draggable handle=".draggable-handle">
            <div className='modal-overlay'>
                <div className="fixed inset-0 flex items-center  max-h-[60%] my-24 justify-center z-50 ">
                    <div className="relative bg-white border shadow-lg max-w-[90%] mt-7 w-auto h-auto">
                        <div className="w-full h-10 bg-primary">
                            <button
                                type="button"
                                className="absolute top-0 left-4 text-4xl text-g text-light"
                                onClick={onback}
                                style={{ zIndex: 10 }}
                            >
                                &larr;
                            </button>
                            <button
                                type="button"
                                className="absolute top-0 right-4 text-4xl text-g text-light"
                                onClick={onClose}
                                style={{ zIndex: 10 }}
                            >
                                &times;
                            </button>
                        </div>
                        <div className="p-6 pt-14 overflow-y-auto h-auto" style={{ maxHeight: 'calc(100vh - 20rem)' }}>
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </Draggable>
    );
};


export default PopupMobile;
